module.exports = __webpack_public_path__ + "img/和牛.42414d8f.png";